import Button from '@/components/Button'
import { MUTATE_DATA } from '@/fragments/GravityForms'
import {
  handleCaptcha,
  handleInputChange,
  handleSubfieldsInputChange,
  useFieldValues,
  useOptionsState
} from '@/utilities/gravityForms/gfFieldsInputHandlers'
import { validateOnSubmit } from '@/utilities/gravityForms/gfFieldsValidation'
import { useMutation } from '@apollo/client'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/sharp-solid-svg-icons'
import { useEffect, useState } from 'react'
import FormFields from '../FormFields' //
import styles from './SingleColumnContactForm.module.scss'

export default function Form(form) {
  const { submitButton, formFields, databaseId } = form.form
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { fieldValuesArray, fieldValues, clearForm, updateFieldValue } = useFieldValues(formFields)
  const { selectStates, handleFileChange, handleOptionClick, resetSelectStates, toggleDropdown, dropdownRefs } = useOptionsState()
  // Add form error state
  const [formError, setFormError] = useState(null)

  //This form uses modal for form submission notification, closes after 4 seconds and clears out form fields
  const [isModalOpen, setModalOpen] = useState(true)

  const clearContactForm = () => {
    clearForm()
    resetSelectStates()
  }

  const [updateData] = useMutation(MUTATE_DATA)

  const handleSubmit = async (e) => {
    e.preventDefault()
    const isValid = validateOnSubmit(formFields, fieldValues)

    if (!isValid) {
      e.stopPropagation()
      setFormError('Please complete all required fields correctly.')
      return false
    }

    try {
      setIsSubmitting(true)
      await updateData({
        variables: { fieldValues: fieldValuesArray, databaseId }
      })
      setIsFormSubmitted(true)
      setModalOpen(true)
      clearContactForm()
    } catch (error) {
      console.error('Form submission error:', error)
    } finally {
      setIsSubmitting(false)
    }
  }

  useEffect(() => {
    let timer
    if (isModalOpen) {
      timer = setTimeout(() => {
        setModalOpen(false)
      }, 4000)
    }
    return () => clearTimeout(timer)
  }, [isModalOpen])

  return (
    <div className={styles.contactFooterForm} id="single-col-contact-form">
      <div className={styles.GravityForm}>
        {isFormSubmitted ? (
          <div className={styles.confirmationMessage}>
            <h3>Thank You for Your Submission!</h3>
            <p>
              We appreciate your interest in partnering with us. Our team will review your information and get in touch with you soon to
              discuss potential collaboration opportunities.
            </p>
          </div>
        ) : (
          <>
            <h2>Ready to collaborate?</h2>
            <form onSubmit={handleSubmit}>
              <FormFields
                formFields={formFields}
                formState={{
                  fieldValues,
                  fieldValuesArray,
                  updateFieldValue,
                  selectStates,
                  dropdownRefs
                }}
                handlers={{
                  handleInputChange,
                  handleSubfieldsInputChange,
                  handleCaptcha,
                  handleFileChange,
                  handleOptionClick,
                  toggleDropdown
                }}
              />

              {/* Form error message display */}
              {formError && (
                <div className="error-container">
                  <div className={styles.formError}>
                    <p className="error-text">{formError}</p>
                  </div>
                </div>
              )}

              <div className={styles.submit}>
                <Button className={`${styles.formButtons} ${isSubmitting ? styles.disabled : ''}`} disabled={isSubmitting}>
                  {submitButton.text}
                  <FontAwesomeIcon icon={faArrowRight} className={styles.icon} />
                </Button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  )
}
